module.exports = __webpack_public_path__ + "img/camera.02fc290d.png";